function TechnologyImg() {
    return (
        <div className="absolute w-96 mt-3 top-52 right-0">
            <img src="assets/technology/image-launch-vehicle-portrait.jpg" alt="Vehicle"/>
        </div>
    );
}
export default TechnologyImg;